<template>
  <div>
    <div class="index" v-if="!detail.show">
      <div class="title">
        <div class="span1">
          <span>基本信息</span>
        </div>
      </div>

      <div>
        <el-form :model="queryParams">
          <div class="title_samll">
            <div class="title_mage"><img src="@/assets/img/peple.png" alt=""></div> <div class="title_msg">账号信息</div>
          </div>
          <el-form-item label="姓名">
              <!-- <el-input
              v-model="queryParams.name"
              placeholder="请输入"
              :disabled="true"
            ></el-input> -->
            <span> {{queryParams.name ||'无' }} </span>
          </el-form-item>
            <el-form-item label="身份证号">
            <span> {{queryParams.card_code||'无'}} </span>
          </el-form-item>
           <el-form-item label="邮箱">
             <span> {{queryParams.email ||'无'}} </span>
          </el-form-item>
          <el-form-item label="手机号">
            <span> {{queryParams.phone ||'无'}} </span>
          </el-form-item>
          <div class="title_samll border_top">
             <div class="title_mage"><img src="@/assets/img/list.png" alt=""></div> <div class="title_msg">机构主体信息</div>
          </div>
          <el-form-item label="机构名称">
             <span> {{queryParams.org_name ||'无'}} </span>
          </el-form-item>
          <el-form-item label="机构地址">
            <span> {{queryParams.org_address ||'无'}} </span>
          </el-form-item>
          <el-form-item label="法人姓名">
            <span> {{queryParams.school_legal_person_name ||'无'}} </span>
          </el-form-item>
          <el-form-item label="机构电话">
             <span> {{queryParams.org_telephone ||'无'}} </span>
          </el-form-item>
          <el-form-item label="执照代码">
            <span> {{queryParams.org_code_certificate ||'无'}} </span>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import {getOrgInfo,getUserInfo,getMemberInfo} from "@/api/user/userCenter";
export default {
  data() {
    return {
      queryParams: {
        name: "",
        email: "",
        org_name: "" ,
        org_short_name: "" ,
        org_telephone: "" ,
        org_address: "",
        org_category_title:"",
        card_code:"",
        phone:"",
        org_code_certificate:"",//组织机构认证代码
        school_legal_person_name:"",//法人代表姓名
      },
      monthList: [], // 月份列表
      typeList: [
        { id: "0", label: "全部教师" },
        { id: "1", label: "校内教师" },
        { id: "2", label: "机构教师" },
      ],
      stateList: [
        { id: "1", label: "已确认" },
        { id: "2", label: "未确认" },
      ],
      detail: {
        info: { title: "赵兵 9月课酬详情" },
        show: false,
      },
    };
  },
  watch: {},
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      let params = {
        org_id:sessionStorage.getItem("orgId"), //机构、学校等组织id
        field:'org_code_certificate,org_address,school_legal_person_name,school_legal_person_code,org_telephone,org_social_credit_code', //是否查更多详情(1要查，0不查)默认不查
      };
      const {code,result}= await getOrgInfo(params);
      if(code==='000000'){
        //   for (let k in result) {
        //   this.queryParams[k] = this.result[k] ;
        // }
          console.log('用户中心获取机构信息----',result);
         this.queryParams.org_name=result.org_name
         this.queryParams.org_short_name=result.org_short_name
         this.queryParams.org_telephone=result.org_telephone
         this.queryParams.org_address=result.org_address
         this.queryParams.org_category_title=result.org_category_title,
         this.queryParams.org_code_certificate=result.org_code_certificate,//org_social_credit_code
         this.queryParams.school_legal_person_name=result.school_legal_person_name
      }else{
        console.log('用户中心获取机构信息失败');
      }
      let paramsData = {
        user_id:JSON.parse(window.sessionStorage.getItem("Userlist")).userId,
        top_org_id:sessionStorage.getItem("orgId")
      };
      getMemberInfo(paramsData).then(res=>{
          console.log('用户中心获取用户信息----',res);
         if(res.code == "000000"){
             this.queryParams.name=res.result.name
             this.queryParams.email=res.result.email
             this.queryParams.card_code=res.result.card_code
             this.queryParams.phone=res.result.phone
         } 
      })
    },

  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .title {
    height: 60px;
    line-height: 48px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-start;
    .span1 {
      font-family: "PingFang SC Bold";
      font-weight: bold;
      font-size: 20px;
      text-align: left;
      color: #000;
      margin-right: 30px;
    }
  }
   .border_top{
      border-top: 1px solid #eaeaea;
    }
  .title_samll{
    margin: 20px 0;
    padding-top: 20px;
     display: flex;
     justify-content: left;
     align-items: center;
     .title_mage{
       margin-right: 15px;
     }
     .title_msg{
       margin-bottom: 3px;
     }
    img{
      width: 16px;
      height:16px;
    }
    span{
      margin-bottom: 5px;
      margin-left: 10px;
      font-family: "PingFang SC Bold";
      font-weight: bold;
      font-size: 14px;
      text-align: left;
      color: #181c26;
    }
  }

  ::v-deep .el-form .el-input__inner {
    width: 400px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
  .el-input{
    width: 200px;
  }
  .el-form-item {
    margin-bottom: 22px;
    margin-left: 33px;
}
}
</style>
